/**
 * uploadEventUtils.js
 * Utility functions for dispatching upload-related custom events
 */
import {clientSideEventNames} from './uiconstants';
import {raiseInformationMessage} from '../actions/erroractions';

/**
 * Dispatches an uploadInfo custom event to notify listeners about informational messages during upload
 * This event will be caught by FileUpload component which emits it to the parent app via message hub in MFE mode
 *
 * @param {string} message - The informational message to display
 * @param {number} [autoDismissInSeconds=0] - Time in seconds before the message auto-dismisses (0 = no auto-dismiss)
 * @param {boolean} isMFE - Indicates whether the app is running in MFE mode; if false, Redux dispatch is used instead of a CustomEvent
 * @param {Function} dispatch - Redux dispatch function used to raise the information message when not in MFE mode
 */
export const dispatchUploadInfoEvent = (message, autoDismissInSeconds = 0, isMFE, dispatch) => {
	if (isMFE) {
		window.dispatchEvent(
			new CustomEvent(clientSideEventNames.uploadInfo, {
				detail: {
					message,
					autoDismissInSeconds
				}
			})
		);
	} else {
		dispatch(raiseInformationMessage(null, message, autoDismissInSeconds));
	}
};

/**
 * Dispatches an uploadError custom event to notify listeners about errors during upload
 * This event will be caught by FileUpload component which emits it to the parent app via message hub in MFE mode
 *
 * @param {Object} error - The error object
 * @param {string} fileId - The ID of the file that failed to upload
 * @param {string} fileName - The name of the file that failed to upload
 */
export const dispatchUploadErrorEvent = (error, fileId, fileName) => {
	window.dispatchEvent(
		new CustomEvent(clientSideEventNames.uploadError, {
			detail: {
				error,
				fileId,
				fileName
			}
		})
	);
};
